import lsqMarvinExternalAppIntegrator from './external-app-integrator';
export default lsqMarvinExternalAppIntegrator;

//test commi